module.exports = __webpack_public_path__ + "excel_logo.svg?c701ad01c06c69e9236dc28c1eada4f0";


//////////////////
// WEBPACK FOOTER
// ./client/src/assets/images/excel_logo.svg
// module id = 463
// module chunks = 0